import * as React from "react";
import * as ReactDOM from "react-dom";
import { useFormikContext, Field, Form, Formik, FormikProps, FormikTouched, isEmptyArray } from 'formik';
import { WorkStatus, HomeStatus, LoanPurpose, CivilStatus } from "./applicationEnums"
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import ApplicationDeclined from "../application-response/ApplicationDeclined";
import ApplicationAccepted from "../application-response/ApplicationAccepted";
import { trackEvent } from "../util/gtm";
import { validationSchema } from "./validation";
import { APIApi } from "../lib-api";
import { ApiConfiguration } from "../src/apiConfiguration";

interface Props {
    applicationCms;
    isLandingPage: boolean;
    bulletPoints;
    mobileBulletPoints;
    isFaqPage: boolean;
    stepOneImage;
    stepOneText;
    stepTwoImage;
    stepTwoText;
    stepThreeImage;
    stepThreeText;
    faqs: object[];
}

export function ThousandSeperator(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

function facebookTracking(amount: number) {
    (window as any).facebookEvent(amount);
}

export interface FormValues {
    applicationId: number,
    amount: number,
    inputamount: number,
    repaymentTime: number,
    email?: string,
    phoneNumber?: string,
    oldLoanExist: boolean,
    oldLoan: number,
    stepTwo: boolean,
    workStatus?: string,
    workStatusSince?: Date,
    income?: number,
    livingCost?: number,
    loanPurpose?: string,
    employer?: string,
    employerPhone?: string,
    idNumber?: string,
    homeStatus?: string,
    civilStatus?: string,
    children?: number,
    partnerExist?: boolean,
    partnerIdNumber?: string,
    partnerEmail?: string,
    partnerPhoneNumber?: string,
    partnerChildren?: number,
    partnerEmployer?: string,
    partnerEmployerPhone?: string,
    partnerWorkStatus?: string,
    partnerWorkStatusSince?: Date,
    partnerLivingCost?: number,
    partnerCivilStatus?: string,
    partnerHomeStatus?: string,
    partnerIncome?: number,
    originReference: string,
    acceptMail: boolean,
}



const ApplicationForm: React.FunctionComponent<Props> = prop => {
    console.log(prop)
    const startvalue = () => {
        var int = 150000
        if (prop.applicationCms.startValue.value != null)
            int = parseInt(prop.applicationCms.startValue.value);
        return int
    }
    const ref = React.createRef<HTMLDivElement>();
    const drawBulletPoints = (isDesktop: boolean) => {
        let bullets;
        if (isDesktop) {
            if (prop.bulletPoints != undefined && prop.bulletPoints.length != 0) {
                bullets = prop.bulletPoints
            }
            else {
                bullets = prop.applicationCms.teasersDesktop.value.split(";")
            }
        }
        else {
            if (prop.mobileBulletPoints != undefined && prop.mobileBulletPoints.length != 0) {
                bullets = prop.mobileBulletPoints

            }
            else {
                bullets = prop.applicationCms.teasersMobile.value.split(";")

            }

        }
        let list = []
        for (let i = 0; i < bullets.length; i++) {
            const bullet = bullets[i]
            list.push(
                <div className="point"><img src={bullet.icon != null ? ("/uploads/" + bullet.icon.id + "-" + bullet.icon.media.filename) : ("/images/check.svg")} alt={bullet.icon != null ? (bullet.icon.media.filename) : ("checkmark")} /> {bullet.text != undefined ? bullet.text.value : bullet}</div>
            )
        }



        return list;
    }
    const stepTwo = () => {
        return window.location.href.includes("#ansokan");
    }
    const getBodyText = () => {
        if (prop.applicationCms.mobileBody.value) {
            return prop.applicationCms.mobileBody.value
        }
        else {
            return prop.applicationCms.body.value
        }
    }


    function showMorefaq(id) {
        console.log(id)
        var height = "500px"      
        var answer = document.getElementById("answer-" + id);
        if (answer != undefined) {
            if (answer.style.maxHeight != height) {
                answer.style.maxHeight = height
                answer.style.transition = "max-height 0.5s ease-in"
            } else {
                answer.style.maxHeight = "0px"
                answer.style.transition = "max-height 0.5s ease-out"

            }
        }
    }

    const drawFaqs = () => {
        let list = []
        if (prop.faqs != undefined) {
            for (let i = 0; i < prop.faqs.length; i++) {
                let faq: any = prop.faqs[i]
                console.log(faq)
                list.push(<div className="col-lg-6 col-12">
                    <div className="faq row" onClick={() => showMorefaq(faq.id)}>
                        <h6 className="col-10 col-lg-11 mb-0"><strong>{faq.question}</strong></h6>
                        <img src="/images/arrow-down.svg" />
                        <div id={"answer-" + faq.id} className="answer col-12" dangerouslySetInnerHTML={{ __html: faq.answer }}>                            
                        </div>
                    </div>
                </div>)
            }
        }
        return list

    }

    const initialValues: FormValues = {
        applicationId: 0, amount: startvalue(), inputamount: startvalue(), repaymentTime: 10, oldLoanExist: prop.applicationCms.isSamleLaan.value, oldLoan: startvalue(), stepTwo: stepTwo(),
        originReference: window.location.href, acceptMail: true
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, helpers) => {
                const api = new APIApi(ApiConfiguration)
                await new Promise(resolve => setTimeout(resolve, 500));

                if (typeof values.income == "string") {
                    values.income = Number((values.income as string).replace(" ", ""))
                }

                if (typeof values.livingCost == "string") {
                    values.livingCost = Number((values.livingCost as string).replace(" ", ""))
                }

                if (typeof values.workStatusSince == "string") {
                    values.workStatusSince = new Date(values.workStatusSince)
                }

                if (typeof values.partnerWorkStatusSince == "string") {
                    values.workStatusSince = new Date(values.partnerWorkStatusSince)
                }

                if (!values.stepTwo) {
                    values.stepTwo = true
                    helpers.resetForm({ values })
                    window.scrollTo(0, ref.current.offsetTop)
                    trackEvent("Permission lead", "Step 1")
                }
                else {
                    const res = await api.postApplication({ applicationRequest: values })


                    if (res.success == "true" && res.good == true) {
                        trackEvent("Send Application", "Accepted")
                        facebookTracking(values.amount);

                        ReactDOM.render(
                            <ApplicationAccepted amount={values.amount} />,
                            document.getElementsByClassName("header-section")[0]
                        );
                    }
                    else if (res.success.toLowerCase() == "ssnissue") {
                        helpers.setFieldError("idNumber", "Personnummer är inte giltigt")
                    }
                    else {
                        trackEvent("Send Application", "Declined")

                        ReactDOM.render(
                            <ApplicationDeclined amount={values.amount} repaymentTime={values.repaymentTime} />,
                            document.getElementsByClassName("header-section")[0]
                        );

                    }
                }
            }}
            validationSchema={validationSchema}
        >
            {props => {
                const {
                    values,
                    touched,
                    errors,
                    isSubmitting,
                    handleChange,
                    handleSubmit,
                    isValid,
                    submitCount,
                } = props;
                //React.useLayoutEffect(() => {
                //    if (submitCount > 0 && !isValid) {
                //        window.scrollTo(0, ref.current.offsetTop)
                //    }
                //}, [submitCount, isValid])


                return (
                    <div>
                        <div className={(values.stepTwo || prop.isFaqPage) ? "application-section stepTwo-bg" : "application-section"} id="applynow">
                            <div className="header-section container">
                                <form onSubmit={handleSubmit}>
                                    {!values.stepTwo &&
                                            <div className="row">
                                                {!prop.isFaqPage &&
                                                    <div className="col-lg-5 cms" >
                                                        {prop.applicationCms.headLine.value && <div dangerouslySetInnerHTML={{ __html: prop.applicationCms.headLine.value }} />}
                                                        {prop.applicationCms.teasersDesktop.value &&
                                                            <div className="bulletpoints d-none d-lg-block">
                                                                <div >
                                                                    {drawBulletPoints(true)}
                                                                </div>
                                                            </div>
                                                        }
                                                        {prop.applicationCms.teasersMobile.value &&
                                                            <div className="d-lg-none">
                                                                <ul className="row bulletpoints">
                                                                    {drawBulletPoints(false)}
                                                                </ul>
                                                            </div>
                                                        }
                                                        {prop.applicationCms.body.value && <div className="d-none d-lg-block" dangerouslySetInnerHTML={{ __html: prop.applicationCms.body.value }} />}
                                                        <div className="row justify-content-between stepsToTake steps-desktop ">

                                                            {prop.applicationCms.stepOneImage.media &&
                                                                <div className=" col-3 text-center ">
                                                                    <div>
                                                                        <img src={prop.applicationCms.stepOneImage.media.publicUrl.replace("~/", "")} className="img-fluid" />
                                                                    </div>
                                                                </div>}
                                                            {prop.applicationCms.stepOneImage.media && <div className="col-1 text-center ">
                                                                <img src="uploads/96bd7942-c348-400b-b2ac-0297127173a4-arrow.svg" className="img-fluid arrow" />
                                                            </div>}
                                                            {prop.applicationCms.stepTwoImage.media &&
                                                                <div className=" col-3 text-center justify-content-center ">
                                                                    <div>
                                                                        <img src={prop.applicationCms.stepTwoImage.media.publicUrl.replace("~/", "")} className="img-fluid" />
                                                                    </div>
                                                                </div>}
                                                            {prop.applicationCms.stepTwoImage.media && <div className="col-1 text-center ">
                                                                <img src="uploads/96bd7942-c348-400b-b2ac-0297127173a4-arrow.svg" className="img-fluid arrow" />
                                                            </div>}


                                                            {prop.applicationCms.stepThreeImage.media &&
                                                                <div className=" col-3 text-center ">
                                                                    <div>
                                                                        <img src={prop.applicationCms.stepThreeImage.media.publicUrl.replace("~/", "")} className="img-fluid" />
                                                                    </div>
                                                                </div>}







                                                            {prop.applicationCms.stepOneImage.media &&
                                                                <div className=" col-3 text-center ">
                                                                    <div>
                                                                        {prop.applicationCms.stepOneText.value}
                                                                    </div>
                                                                </div>}
                                                            {prop.applicationCms.stepOneImage.media && <div className="col-1 text-center ">
                                                            </div>}
                                                            {prop.applicationCms.stepTwoImage.media &&
                                                                <div className=" col-3 text-center justify-content-center ">
                                                                    <div>
                                                                        {prop.applicationCms.stepTwoText.value}
                                                                    </div>
                                                                </div>}
                                                            {prop.applicationCms.stepTwoImage.media && <div className="col-1 text-center ">
                                                            </div>}


                                                            {prop.applicationCms.stepThreeImage.media &&
                                                                <div className=" col-3 text-center ">
                                                                    <div>
                                                                        {prop.applicationCms.stepThreeText.value}
                                                                    </div>
                                                                </div>}



                                                        </div>
                                                    </div>
                                                }
                                            {prop.isFaqPage &&
                                                <div className="col-lg-7 faqs row">
                                                        {drawFaqs()}
                                                    </div>
                                                }

                                        <div className={prop.isFaqPage ? "col-lg-5 form-wrapper" : prop.isLandingPage ? "col-lg-5 offset-lg-2  form-wrapper landing-page" : "col-lg-5 offset-lg-2  form-wrapper"} id="form-wrapper" >
                                                    <div className="form-container" id={prop.isLandingPage ? "form-container" : ""}>
                                                        <StepOne />
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                    {values.stepTwo &&
                                        <div className="row">
                                            <div className="col-lg-10 offset-lg-1 form-wrapper">
                                                <div className="form-container">
                                                    <div>
                                                        <StepTwo />
                                                        <div className="col-lg-8 offset-lg-2">
                                                            <button type="submit" disabled={isSubmitting} className={!isValid ? "submit btn-green btn-grey" : "submit btn-green shine"} >Få låneerbjudanden</button>
                                                            <div className="input-error">{!isValid && <label className="error">Fel i inträde</label>} </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {!values.stepTwo &&
                                        <div className="cms d-lg-none">
                                            {prop.applicationCms.body.value && <div dangerouslySetInnerHTML={{ __html: getBodyText() }} />}
                                        </div>
                                    }
                                    <div className="row justify-content-between stepsToTake d-lg-none">

                                        {prop.applicationCms.stepOneImage.media &&
                                            <div className=" col-3 text-center">
                                                <div>
                                                    <img src={prop.applicationCms.stepOneImage.media.publicUrl.replace("~/", "")} className="img-fluid" />
                                                </div>
                                            </div>}
                                        {prop.applicationCms.stepOneImage.media && <div className="col-1 text-center">
                                            <img src="uploads/96bd7942-c348-400b-b2ac-0297127173a4-arrow.svg" className="img-fluid arrow" />
                                        </div>}
                                        {prop.applicationCms.stepTwoImage.media &&
                                            <div className=" col-3 text-center justify-content-center">
                                                <div>
                                                    <img src={prop.applicationCms.stepTwoImage.media.publicUrl.replace("~/", "")} className="img-fluid" />
                                                </div>
                                            </div>}
                                        {prop.applicationCms.stepTwoImage.media && <div className="col-1 text-center">
                                            <img src="uploads/96bd7942-c348-400b-b2ac-0297127173a4-arrow.svg" className="img-fluid arrow" />
                                        </div>}


                                        {prop.applicationCms.stepThreeImage.media &&
                                            <div className=" col-3 text-center">
                                                <div>
                                                    <img src={prop.applicationCms.stepThreeImage.media.publicUrl.replace("~/", "")} className="img-fluid" />
                                                </div>
                                            </div>}







                                        {prop.applicationCms.stepOneImage.media &&
                                            <div className=" col-3 text-center">
                                                <div>
                                                    {prop.applicationCms.stepOneText.value}
                                                </div>
                                            </div>}
                                        {prop.applicationCms.stepOneImage.media && <div className="col-1 text-center">
                                        </div>}
                                        {prop.applicationCms.stepTwoImage.media &&
                                            <div className=" col-3 text-center justify-content-center">
                                                <div>
                                                    {prop.applicationCms.stepTwoText.value}
                                                </div>
                                            </div>}
                                        {prop.applicationCms.stepTwoImage.media && <div className="col-1 text-center">
                                        </div>}


                                        {prop.applicationCms.stepThreeImage.media &&
                                            <div className=" col-3 text-center">
                                                <div>
                                                    {prop.applicationCms.stepThreeText.value}
                                                </div>
                                            </div>}



                                    </div>

                                </form>
                            </div>
                        </div>
                        <div id="below-offset" />

                    </div>
                );
            }}
        </Formik>
    )
}


export default ApplicationForm;